import React from "react";
import { Dimensions, Platform, StyleSheet, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, ImageSizeTokens, SizeTypeTokens, TextAlignTokens, } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import { Button } from "../../button/Button";
import { Space } from "../../space/Space";
import { Image } from "../../image/Image";
const FailurePage = ({ height, title, subtitle, imageUrl, contactUsAction, triggerAction }) => {
    const handleNeedHelp = () => {
        contactUsAction &&
            triggerAction(contactUsAction);
    };
    const _bodyChild = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: styles.imageContainer },
                React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: `${imageUrl}`, width: 64, height: 64 })),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(Typography, { label: `${title}`, fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }),
            React.createElement(Space, { size: SizeTypeTokens.SM }),
            React.createElement(Typography, { label: `${subtitle}`, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })));
    };
    const _footerChild = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: styles.footerContainer },
                React.createElement(View, { style: {
                        width: '100%'
                    } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: 'Need help? Contact us', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            handleNeedHelp();
                        } })))));
    };
    return (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 15 : height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: [styles.body, { height: height - 75 }] }, _bodyChild()),
            React.createElement(View, { style: styles.footer }, _footerChild()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 56,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    bodyContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContainer: {
        padding: 16
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 16
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 5,
        width: '100%',
    },
    imageContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    footerContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        padding: 16
    }
});
export default (FailurePage);
